//fetchUserBusinesses.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../api'; // adjust if your axios instance is elsewhere

// Thunks for fetching user-businesses
export const fetchUserBusinesses = createAsyncThunk(
  'userBusinesses/fetchUserBusinesses',
  async (email, { rejectWithValue }) => {
    try {
      // Make a GET request to fetch user-businesses by passing the email as a parameter
      const response = await api.post(`/user-businesses`, {
        email,
      });
      
      const sortedData = response.data.map((business) => ({
        ...business,
        stores: business.stores.sort((a, b) => a.store_name.localeCompare(b.store_name)),
      }));
      
      return sortedData;
    } catch (error) {
      return rejectWithValue(error.response?.statusText || error.message);
    }
  }
);

// Thunks for adding a new business
export const addBusiness = createAsyncThunk(
  'userBusinesses/addBusiness',
  async ({ name, email }, { rejectWithValue }) => {
    try {
      const response = await api.post('/businesses', { name, email });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);


const userBusinessesSlice = createSlice({
    name: 'userBusinesses',
    initialState: {
        items: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
        // Handle fetchUserBusinesses
        .addCase(fetchUserBusinesses.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchUserBusinesses.fulfilled, (state, action) => {
            state.loading = false;
            state.items = action.payload;
        })
        .addCase(fetchUserBusinesses.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        // Handle addBusiness
        .addCase(addBusiness.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(addBusiness.fulfilled, (state, action) => {
            state.loading = false;
            // Optionally, you can add the new business to the state here
            // or just refetch the list of businesses as you are doing in the component.
        })
        .addCase(addBusiness.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
    });

    export default userBusinessesSlice.reducer;
